module.exports = __webpack_public_path__ + "static/media/guy-crouching.dfc852c6.png";